
    var riot = require('riot')
    
riot.tag2('wrapper', '<yield></yield>', '', '', function(opts) {
});
    
  